import React from "react";

import VStack from "../../ui_atoms/VStack";
import type { Meta, StoryObj } from "@storybook/react";
import SvgImage from "../../assets/images/avatar_1.svg";

function StoryComponent() {
    return (
        <VStack
            gap={0.5}
            h={1}
            alignment="center"
            style={{
                margin: 10,
                alignSelf: "stretch",
            }}
        >
            <SvgImage height={100} width={100} />
        </VStack>
    );
}

const meta = {
    title: "Atom/Svg",
    component: StoryComponent,
    argTypes: {},
} satisfies Meta<typeof StoryComponent>;

export default meta;

type Story = StoryObj<typeof meta>;

export const Default: Story = {};
